import { Helmet } from "react-helmet";
import React, { useState } from "react";
import PreviousVideos from "../BasicsTraining/PreviousVideos";
import "./style.scss";
import VerifiedIcon from "@mui/icons-material/Verified";
import DaneProfileImage from "../../assets/images/dane.png";
import { defaultVideoState } from "../../helpers/defaultVideoState";

function MarketAnalysis() {
  const [currentVideo, setCurrentVideo] = useState(defaultVideoState);

  const [tab, setTab] = useState("1");
  return (
    <div className="container-xl-live">
      <Helmet>
        <title>Live Trading Room | TradeAlgo</title>
      </Helmet>

      {currentVideo.live ? (
        <div className="market-analysis-hero">
          <iframe
            className="market-analysis-event-video"
            src="https://vimeo.com/event/1439418/embed/interaction"
            width="1920"
            height="1080"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            title="market-analysis-video"
          ></iframe>
        </div>
      ) : (
        <div>
          <div
            dangerouslySetInnerHTML={{
              __html: currentVideo.url,
            }}
          />
          <div style={{ position: "relative", top: "5px", left: "29px" }}>
            <div className="row">
              <span
                className="col-12"
                style={{ color: "#A2A3A5", whiteSpace: "nowrap" }}
              >
                {currentVideo.duration} | {currentVideo.date} |{" "}
                {tab === "1" ? "Group Training" : ""}
              </span>
            </div>
            <div className="row">
              <span className="col-12" style={{ paddingTop: "10px" }}>
                {currentVideo.description}
              </span>
            </div>
          </div>
          <br />
          <div
            style={{
              width: "99%",
              border: "1px solid #F1F1F1",
              marginLeft: "24px",
            }}
          ></div>
          <br />
        </div>
      )}

      <div className="market-analysis-presentor-wrapper">
        <div className="market-analysis-half-width">
          <div className="market-analysis-presentor">
            <img
              src={DaneProfileImage}
              alt="profile"
              className="market-analysis-presentor-avatar"
            />
            <div className="market-analysis-presentor-detail">
              <div className="market-analysis-presentor-name">
                Dane Glisek <VerifiedIcon />
              </div>
              <div className="market-analysis-presentor-position">
                TradeAlgo Analyst
              </div>
            </div>
          </div>

          <div className="market-analysis-event-info">
            <div className="market-analysis-event-info-section">
              <div className="market-analysis-event-title">
                Pre-market Analysis Sessions
              </div>
              <div className="market-analysis-event-description">
                <div>
                  Every Monday to Friday
                  <br />
                  9:00AM - 9:30AM EST
                </div>
                <div>
                  Dane will go over TradeAlgo to identify potential dashboard
                  picks,
                  <br />
                  providing levels to watch out for with day-trades and set ups.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="market-analysis-half-width">
          <div
            className="market-analysis-presentor"
            style={{ visibility: "hidden" }}
          >
            <img
              src={DaneProfileImage}
              alt="profile"
              className="market-analysis-presentor-avatar"
            />
            <div className="market-analysis-presentor-detail">
              <div className="market-analysis-presentor-name">
                Dane Glisek <VerifiedIcon />
              </div>
              <div className="market-analysis-presentor-position">
                TradeAlgo Analyst
              </div>
            </div>
          </div>
          <div className="market-analysis-event-info">
            <div className="market-analysis-event-info-section">
              <div className="market-analysis-event-title">
                Live Trading Sessions
              </div>
              <div className="market-analysis-event-description">
                <div>
                  Every Monday to Friday
                  <br />
                  9:30AM - 10:30AM and 3:00PM - 4:00PM EST
                </div>
                <div>
                  These group training sessions are designed to explain how to
                  take
                  <br />
                  full advantage of the alerts TradeAlgo has to offer.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PreviousVideos
        tab={tab}
        setTab={setTab}
        basics={false}
        currentVideo={currentVideo}
        setCurrentVideo={setCurrentVideo}
        videoKey={"market-analysis"}
      />
    </div>
  );
}
export default MarketAnalysis;
